<template>
  <Transition name="pull-refresh">
    <div v-if="pullDistance > 0" class="pull-refresh-indicator" :style="{ transform: `translateY(${pullDistance}px)` }">
      <div class="pull-refresh-content">
        <svg
          class="refresh-icon"
          :class="{ spinning: isRefreshing || isPulling }"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M21 2v6h-6"></path>
          <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
          <path d="M3 22v-6h6"></path>
          <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
        </svg>
        <span class="refresh-text">
          {{ isRefreshing ? '正在刷新...' : isPulling ? '释放立即刷新' : '下拉刷新' }}
        </span>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps<{
  pullDistance: number;
  isPulling: boolean;
  isRefreshing: boolean;
}>();
</script>

<style scoped>
.pull-refresh-indicator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 16px;
}

.pull-refresh-content {
  background: var(--bg-secondary);
  border-radius: 20px;
  padding: 8px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon {
  color: var(--color-primary);
  transition: transform 0.3s ease;
}

.refresh-icon.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.refresh-text {
  font-size: 0.875rem;
  color: var(--text-secondary);
  font-weight: 500;
}

/* 暗夜模式 */
:global(.dark) .pull-refresh-content {
  background: var(--bg-secondary);
}

:global(.dark) .refresh-text {
  color: var(--text-primary);
}

.pull-refresh-enter-active,
.pull-refresh-leave-active {
  transition: opacity 0.3s ease;
}

.pull-refresh-enter-from,
.pull-refresh-leave-to {
  opacity: 0;
}
</style>
